import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PrintConversationIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M14.25 6h-.75V2.25h-9V6h-.75C2.505 6 1.5 7.005 1.5 8.25v4.5h3v3h9v-3h3v-4.5C16.5 7.005 15.495 6 14.25 6ZM6 3.75h6V6H6V3.75Zm6 10.5H6v-3h6v3Zm1.5-3v-1.5h-9v1.5H3v-3c0-.4125.3375-.75.75-.75h10.5c.4125 0 .75.3375.75.75v3h-1.5Z" />
    <path d="M13.5 9.375c.4142 0 .75-.33579.75-.75s-.3358-.75-.75-.75-.75.33579-.75.75.3358.75.75.75Z" />
  </Icon>
);

export default memo(PrintConversationIcon);
